import React from "react";
import { Navbar } from "./navbar";
import { Footer } from "./footer";
import styled from "styled-components";

export const TermsOfUse = () => {
  return (
    <main>
      <Navbar />
      <StyledMain>
        <section class="page-header page-header-classic page-header-md">
          <div class="container">
            <div class="row">
              <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
                <span class="page-header-title-border visible"></span>
                <h1 data-title-border="">Terms of Use</h1>
              </div>
            </div>
          </div>
        </section>
        <div role="main" class="main">
          <div class="container">
            <p>
              <strong>Trovo App Terms of Use</strong>
            </p>
            <p>
              This Trovo App Application (&quot;<strong>Trovo App</strong>
              &quot;) Terms of Use is entered into between you (hereinafter
              referred to as &ldquo;you&rdquo; or &ldquo;your&rdquo;) and
              Trovotech Limited (&ldquo;<strong>Trovotech</strong>&rdquo;)
              incorporated in the Federal Republic of Nigeria. By accessing,
              downloading, using or clicking on &ldquo;I agree&rdquo; to accept
              any Trovo App services (as defined below) provided by
              Trovotech, you agree that you have read, understood and accepted
              all of the terms and conditions stipulated in these Terms of Use
              (hereinafter referred to as &ldquo;these Terms&rdquo;) as well as
              our{" "}
              <span>
                Privacy Policy
              </span>
              . In addition, when using some features of Trovo App, you may
              be subject to specific additional terms and conditions applicable
              to those features.
            </p>
            <p>
              Trovo App is a noncustodial digital assets wallet comprising
              digital asset send, receive, storage, and swaps (all collectively
              defined as Trovo App).
            </p>
            <p>
              <strong>I. Acceptance of the Terms</strong>
            </p>
            <p>
              Before using Trovo App, you must first agree to these Terms and
              the Privacy Policy. By accessing Trovo App or by otherwise
              using Trovo App, you confirm that you agree to these Terms of
              Service. &nbsp;
            </p>
            <p>
              Minors are not allowed to use Trovo App. You affirm that you
              have at least attained the age of majority in the jurisdiction
              where you live or, if you are not, your parent or legal guardian
              must consent to these Terms and affirm that they accept this
              Agreement on your behalf and bear responsibility for your use. If
              you are accepting these Terms on behalf of someone else or an
              entity, you confirm that you have the legal authority to bind that
              person or entity to this Agreement.
            </p>
            <p>
              <strong>II. Change of Terms</strong>
            </p>
            <p>
              We have the right, at our sole discretion, to make modifications
              and revisions to the terms of this Agreement to reflect changes in
              technology, standards, legislation, administrative or business
              practices, or the costs structure for providing Trovo App. Such
              modifications and revisions will be notified to you through Trovo
              App no later than thirty (30) days before they become
              effective.&nbsp;
            </p>
            <p>
              You will be deemed to have accepted all modifications and
              revisions by continuing to use Trovo App. &nbsp;
            </p>
            <p>
              We also have the right, at our sole discretion, to make
              modifications and revisions to Trovo App and to the terms of
              this Agreement at any time which are due to security or compliance
              reasons, or for reasons suspected fraudulent activity. Such
              modifications will be published on our website and notified to you
              without undue delay.&nbsp;
            </p>
            <p>
              <strong>III. On Trovo App </strong>
            </p>
            <p>
              To access Trovo App, users must register and open an account.{" "}
              <span>
                (Please, visit our guide on how to register an account.){" "}
              </span>
            </p>
            <p>
              When setting up an account on Trovo App, you will be
              responsible for keeping your own account secret information, which
              may be a twelve-word seed phrase, your private keys, an account
              file, or other locally stored secret information. Trovo App
              encrypts this information locally with a password you provide,
              that is never sent to our servers.&nbsp;
            </p>
            <p>
              It is very important that you backup your own account secret
              information. If you lose your account secret information, then it
              will not be possible for Trovotech to recover it for you and you
              may lose access to your digital assets. We strictly recommend that
              you follow our <span>user guide </span>before using Trovo App.
            </p>
            <p>
              You agree to (a) never use the same password for Trovo App that
              you have ever used outside of Trovo App, (b) keep your secret
              information and password confidential and do not share them with
              anyone else and (c) immediately notify Trovotech of any
              unauthorized use of your account or breach of security. Trovotech
              cannot and will not be liable for any loss or damage arising from
              your failure to comply with this section.
            </p>
            <p>IV. Eligibility</p>
            <p>
              By registering to use Trovo App, you represent and confirm that
              (i) as an individual, you have attained the age of majority in the
              jurisdiction where you live. If you are not, your parent or legal
              guardian consent to these Terms and affirm that they accept this
              Agreement on your behalf and bear responsibility for your use;
              &nbsp;(ii) If you act as an employee or agent of a legal entity,
              and enter into these Terms on their behalf, you represent and
              confirm that you have all the necessary rights and authorizations
              to bind such legal entity; (iii) your use of Trovo App will not
              violate laws and regulations applicable to you, including but not
              limited to regulations on anti-money laundering, anti-corruption,
              and counter-terrorist financing.
            </p>
            <p>
              <strong>V. Account Security</strong>
            </p>
            <p>
              Trovotech is committed to maintaining the security of user
              entrusted funds, and has implemented industry standard protection
              for Trovo App. However, the actions of individual users may
              pose risks. You agree to treat your access credentials (such as
              password, mnemonic phrases and private keys) as confidential
              information, and not to disclose such information to any third
              party. You also agree to be solely responsible for taking the
              necessary security measures to protect your Trovo App account
              and personal information.
            </p>
            <p>
              <br />
              You shall be solely responsible for all the transactions under
              your Trovo App account. Trovotech assumes no liability for any
              loss or consequences caused by authorized or unauthorized use of
              your account credentials, including but not limited to information
              disclosure, information release, consent or submission of various
              rules and agreements by clicking on the platform, online agreement
              renewal, etc.
            </p>
            <p>
              <br />
            </p>
            <p>By creating a Trovo App account, you hereby agree that:</p>
            <ol>
              <li>
                <p>
                  You will notify Trovotech immediately if you are aware of any
                  unauthorized use of your Trovo App account and password or
                  any other violation of security rules;
                </p>
              </li>
              <li>
                <p>
                  You will strictly abide by all mechanisms or procedures of
                  Trovo App regarding account backup, security,
                  authentication, deposit, trading, charging, and withdrawal;
                  and
                </p>
              </li>
              <li>
                <p>
                  You will take appropriate steps to logout from Trovo App at
                  the end of each visit.
                </p>
              </li>
              <li>
                <p>
                  You will activate multisig where necessary to add mor security
                  to your Trovo App&nbsp;
                </p>
              </li>
            </ol>
            <p>
              <br />
            </p>
            <p>
              <br />
            </p>
            <p>
              <strong>
                VI. Disclaimers, Limitation of Liability and Indemnification
              </strong>
            </p>
            <p>
              To the extent permitted by the laws of the FEDERAL REPUBLIC OF
              NIGERIA, in no event will Trovotech, its affiliates and their
              respective members, directors, officers, employees, attorneys,
              agents, representatives, suppliers or contractors be liable for
              any incidental, indirect, special, punitive, consequential or
              similar damages or liabilities whatsoever (including, without
              limitation, damages for loss of data, information, revenue,
              profits or other businesses or financial benefits) arising out of
              Trovo App, any performance or non-performance of Trovo App,
              or any other product, service or other item provided by or on
              behalf of Trovotech and its affiliates, whether under contract,
              statute, strict liability or other theory even if Trovotech has
              been advised of the possibility of such damages except to the
              extent of a final judicial determination that such damages were a
              result of Trovotech&rsquo;s gross negligence, fraud, willful
              misconduct or intentional violation of law.&nbsp;
            </p>
            <p>
              You agree to indemnify and hold harmless Trovotech, its
              affiliates, contractors, licensors, and their respective
              directors, officers, employees and agents from and against any
              claims, actions, proceedings, investigations, demands, suits,
              costs, expenses and damages (including attorneys&rsquo; fees,
              fines or penalties imposed by any regulatory authority) arising
              out of or related to (i) your use of, or conduct in connection
              with, Trovo App, (ii) your breach or our enforcement of these
              Terms, or (iii) your violation of any applicable law, regulation,
              or rights of any third party during your use of Trovo App. If
              you are obligated to indemnify Trovo App operators, their
              affiliates, contractors, licensors, and their respective
              directors, officers, employees or agents pursuant to these Terms,
              Trovotech will have the right, in its sole discretion, to control
              any action or proceeding and to determine whether Trovotech
              &nbsp;wishes to settle, and if so, on what terms.
            </p>
            <p>
              <strong>VII. Intellectual Property</strong>
            </p>
            <ol>
              <li>
                <p>
                  <strong>Our Proprietary Rights:</strong>&nbsp;All title,
                  ownership and intellectual property rights in and to Trovo
                  App are owned by Trovotech or its licensors. You
                  acknowledge and agree that Trovo App contain proprietary
                  and confidential information that is protected by applicable
                  intellectual property and other laws. Except as expressly
                  authorized by Trovotech, you agree not to copy, modify, rent,
                  lease, loan, sell, distribute, perform, display or create
                  derivative works based on the Site, the App or Trovo App,
                  in whole or in part.
                </p>
              </li>
              <li>
                <p>
                  <strong>Limited License:</strong>&nbsp;We grant you limited,
                  non-exclusive, revocable permission to make use of the Site,
                  the App and Trovo App (collectively, &ldquo;Access&rdquo;).
                  This Access shall remain in effect until and unless terminated
                  by you or us. You promise and agree that you will not
                  redistribute or transfer Trovo App.&nbsp;
                </p>
              </li>
              <li>
                <p>
                  The Trovo App software application, including without
                  limitation the Site, the App and Trovo App, are not sold or
                  transferred to you, and Trovotech and its licensors retain
                  ownership of all copies of the software applications even
                  after installation on your personal computers, mobile
                  handsets, tablets, wearable devices and/or other devices
                  (&ldquo;Devices&rdquo;).
                </p>
              </li>
              <li>
                <p>
                  All Trovotech trademarks, service marks, trade names, logos,
                  domain names, and any other features of the Trovotech brand
                  (&ldquo;Trovotech Brand Features&rdquo;) are the sole property
                  of Trovotech or its licensors. The Terms do not grant you any
                  rights to use any Trovotech Brand Features whether for
                  commercial or non-commercial use.
                </p>
              </li>
              <li>
                <p>
                  You agree to abide by our user guidelines and not to use Trovo
                  App or any part thereof in any manner not expressly
                  permitted by the Terms. Except for the rights expressly
                  granted to you in the Terms, Trovotech grants no right, title,
                  or interest to you in the Site, the App or Trovo App.
                </p>
              </li>
              <li>
                <p>
                  Third party software (for example, open source software
                  libraries) included in Trovo App are made available to you
                  under the relevant third party software library&rsquo;s
                  license terms.
                </p>
              </li>
              <li>
                <p>
                  Notwithstanding anything herein to the contrary, nothing in
                  the Terms entitles you to copy, modify, fork, merge, combine
                  with another program or create a derivative work of Trovo
                  App, including without limitation the Site and the App.
                </p>
              </li>
            </ol>
            <p>
              <strong>
                VIII. Sophistication and Risk of Cryptographic Systems
              </strong>
            </p>
            <p>
              By utilizing Trovo App or interacting with our content or
              platform in any way, you represent that you understand the
              inherent risks associated with cryptographic systems; and warrant
              that you have an understanding of the usage and intricacies of
              native cryptographic tokens, smart contract based tokens and
              blockchain-based software systems, including forks.
            </p>
            <p>
              <strong>IX. No financial advice </strong>
            </p>
            <p>
              Trovotech is not a broker, intermediary, agent, or advisor and has
              no fiduciary relationship or obligation to you in connection with
              any trades or other decisions or activities effected by you using
              Trovo App. No communication or information provided to you on
              the Trovo App platform is intended as, or shall be considered
              or construed as, investment advice, financial advice, trading
              advice, or any other sort of advice.&nbsp;
            </p>
            <p>
              <strong>X. Termination and Suspension </strong>&nbsp;
            </p>
            <p>
              Trovotech may terminate or suspend all or part of our services and
              your Trovo App access immediately, without prior notice or
              liability, if you breach any of the terms or conditions of the
              Terms. Upon termination of your access, your right to use Trovo
              App will immediately cease.
            </p>
            <p>
              <strong>XI. Dispute Resolution</strong>
            </p>
            <p>
              This Agreement and any action arising out of your use of Trovo
              App will be governed by and construed in accordance with the
              LAWS OF THE FEDERAL REPUBLIC OF NIGERIA. Unless submitted to
              arbitration as set forth in the following paragraph.&nbsp;
            </p>
            <p>
              The party electing such arbitration will initiate the arbitration
              through an established alternative dispute resolution
              (&quot;ADR&quot;) provider mutually agreed upon by the parties.
              The ADR provider and the parties must comply with the following
              rules: a) the arbitration shall be conducted by telephone, online
              and/or be solely based on written submissions, as selected by the
              party initiating the arbitration; b) the arbitration will not
              involve any personal appearance by the parties or witnesses unless
              otherwise mutually agreed by the parties; and c) any judgment on
              the award rendered by the arbitrator may be entered in any court
              of competent jurisdiction.
            </p>
            <p>
              <strong>XII. General Terms</strong>
            </p>
            <p>
              <br />
            </p>
            <ol>
              <li>
                <p>
                  <strong>Governing Law and Jurisdiction. </strong>You agree
                  that Trovo App is operated in Nigeria and will be deemed to
                  be solely based in Nigeria for purposes of jurisdictional
                  analysis. For any claims for which arbitration is
                  inapplicable, you agree that such claims will be brought to
                  the competent jurisdictions of Nigeria and governed by the
                  laws of Nigeria, without regard to any conflict of law
                  provisions.
                </p>
              </li>
              <li>
                <p>
                  <strong>Use Outside of Nigeria.</strong>&nbsp;Trovotech
                  expressly disclaims any representation or warranty that Trovo
                  App complies with all applicable laws and regulations
                  outside of Nigeria. If you accede to Trovo App outside of
                  Nigeria, you expressly understand and agree that you are
                  responsible for determining compliance with different laws,
                  regulations, or customs that may apply in connection with your
                  use of Trovo App.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Risk of Regulatory Actions in One or More Jurisdictions:
                  </strong>
                  &nbsp;Trovo App could be impacted by one or more regulatory
                  inquiries or regulatory action, which could impede or limit
                  the ability of Trovo App to continue to develop, or which
                  could impede or limit your ability to access or use Trovo
                  App.
                </p>
              </li>
              <li>
                <p>
                  <strong>Export.</strong> Trovo App is controlled and
                  operated from our Nigeria offices. Trovo App softwares are
                  subject to Nigeria export controls.&nbsp;
                </p>
              </li>
              <li>
                <p>
                  <strong>Assignment.</strong> You may not assign or transfer
                  this Agreement (or any of your rights or obligations under
                  this Agreement) without our prior written consent; any
                  attempted assignment or transfer without complying with the
                  foregoing will be void.&nbsp;
                </p>
              </li>
              <li>
                <p>
                  <strong>Electronic Communications.</strong> You consent to
                  receive communications from us by email in accordance with
                  this Agreement and applicable law. You acknowledge and agree
                  that all agreements, notices, disclosures and other
                  communications that we provide to you electronically will
                  satisfy any legal requirement that such communications be in
                  writing.
                </p>
              </li>
              <li>
                <p>
                  <strong>Entire Agreement/ Severability.</strong> This
                  Agreement supersedes all prior terms, agreements, discussions
                  and writings regarding Trovo App and constitutes the entire
                  agreement between you and us regarding Trovo App (except as
                  to services that require separate written agreement with us,
                  in addition to this Agreement). If any provision in this
                  Agreement is found to be unenforceable, then that provision
                  will not affect the enforceability of the remaining provisions
                  of the Agreement, which will remain in full force and effect.
                </p>
              </li>
              <li>
                <p>
                  <strong>Interpretation</strong>. In construing or interpreting
                  the terms of this Agreement: (i) the headings in this
                  Agreement are for convenience only, and are not to be
                  considered, and (ii) no presumption is to operate in either
                  party&rsquo;s favor as a result of its counsel&rsquo;s role in
                  drafting this Agreement.
                </p>
              </li>
              <li>
                <p>
                  <strong>Notices.</strong> All notices permitted or required
                  under this Agreement, unless specified otherwise in this
                  Agreement, must be sent in writing as follows in order to be
                  valid: (i) if to you, by us via email to the address
                  associated with your account, and (ii) if to us, by you
                  via&nbsp;legal@trovotech.io&nbsp;notices will be deemed given
                  (a) if to you, when emailed, and (b) if to us, on receipt by
                  us.
                </p>
              </li>
              <li>
                <p>
                  <strong>Relationship.</strong> This Agreement does not create
                  a joint venture, agency, partnership, or other form of joint
                  enterprise between you and us. Except as expressly provided
                  herein, neither party has the right, power, or authority to
                  create any obligation or duty, express or implied, on behalf
                  of the other.
                </p>
              </li>
              <li>
                <p>
                  <strong>Waiver.</strong> No waiver of any terms will be deemed
                  a further or continuing waiver of such term or any other term.
                  Our failure to assert a right or provision under this
                  Agreement will not constitute a waiver of such right or
                  provision.
                </p>
              </li>
              <li>
                <p>
                  <strong>Contact.</strong> Feel free to contact us through
                  legal@trovotech.io with any questions about these terms.&nbsp;
                </p>
              </li>
            </ol>
          </div>
        </div>
      </StyledMain>
      <Footer />
    </main>
  );
};

const StyledMain = styled.main`
  width: 80%;
  margin: auto;
  margin-top: 100px;
  font-family: "Montserrat";
`;
